export function sticky(container, container_position){
  if(window.pageYOffset > container_position){
    container.classList.add("sticky");
  } else {
    container.classList.remove("sticky");
  }
}
